import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { PackageGeneralFormDataProviderFactory } from '../factory/PackageGeneralFormDataProviderFactory';
import { PackageGeneralFormBaseDataProvider } from '../dataProvider/PackageGeneralFormBaseDataProvider';
import { LanguageData } from '../../../types/language-data';

export class PackageGeneralFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackageGeneralFormDataProviderFactory;
  public dataProvider: PackageGeneralFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackageGeneralFormDataProviderFactory(),
    });
  }

  public getLanguages(): LanguageData[] {
    return this.dataProvider.getLanguages();
  }
}
